import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useCurrentUser } from './user/use-current-user.query';
import { Intercom } from '@intercom/messenger-js-sdk';

export const useSosaAppConfig = () => {
  const { data: currentUser } = useCurrentUser();

  useEffect(() => {
    Sentry.setUser({
      id: currentUser?.id,
      email: currentUser?.email,
    });
  }, [currentUser]);

  useEffect(() => {
    if (currentUser) {
      const account = currentUser.account;

      const initIntercom = () => {
        const { VITE_INTERCOM_APP_ID } = window.runTimeEnvs;
        if (VITE_INTERCOM_APP_ID) {
          Intercom({
            app_id: VITE_INTERCOM_APP_ID,
            intercom_user_jwt: currentUser.intercomUserJWT,
            session_duration: 86400000 * 7, // 7 days
          });
        }
      };

      const initPendo = () => {
        if (window.pendo) {
          window.pendo.initialize({
            visitor: {
              id: currentUser.id.toString(),
              email: currentUser.email,
              full_name: `${currentUser.firstName} ${currentUser.lastName}`,
              role: currentUser.role,
              teamId: currentUser.team ? currentUser.team.id : null,
              teamName: currentUser.team ? currentUser.team.name : null,
            },
            account: {
              id: account ? account.id : '',
              name: account ? account.name : '',
            },
          });
        }
      };
      if (account) {
        initIntercom();
        initPendo();
      }
    }
  }, [currentUser]);
};
